import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", { d: "M20.54 9.984v4.123a.694.694 0 01-.356.644l-7.13 4.024c-.639.36-1.418.361-2.057.003L3.82 14.752a.694.694 0 01-.355-.659V9.998a.693.693 0 01.345-.653l7.156-4.172a2.097 2.097 0 012.117.003l7.112 4.17a.693.693 0 01.344.638z" }),
    _createVNode("path", { d: "M3.82 10.558a.699.699 0 01-.01-1.213l7.157-4.172a2.097 2.097 0 012.116.003l7.112 4.17a.699.699 0 01-.01 1.212l-7.132 4.023a2.096 2.096 0 01-2.056.003L3.82 10.558z" })
  ]))
}